import { GuidService } from 'ui-components/services/guid-service';
import { APPLIED_FILTER_OPERATOR_GREATER_THAN } from '../../../../../components/filter-editor/constants/applied-filter-operator';
import { ACTION_TYPE_INSURE_PACKAGE } from '../../../../settings/automation-rules/constants/action-types';
import { OrderTotal } from '../../../../../containers/orders-filter-bar-container/filter-options/options/order-total';
import { messages } from '../messages';

export const prepopulatedInsuranceFilter = {
  column: OrderTotal.filterValue,
  operator: APPLIED_FILTER_OPERATOR_GREATER_THAN,
  workingFilterId: GuidService.newGuid(),
  value: 50,
};

export const prepopulatedInsuranceRule = {
  active: true,
  ruleName: messages.insuranceRuleName,
  orderRuleActions: [
    {
      actionTypeId: ACTION_TYPE_INSURE_PACKAGE,
      intParameter: 5,
      orderRuleActionId: GuidService.newGuid(),
    },
  ],
  isNew: true,
};
